import { aFetch } from 'afetch';
import { KwardaError } from '../../../models/Global';

const endPoints = {
	apiBase: '/api.php',
};

export const sendConfirm = async (data: { kod: string }) => {
	const payload = new FormData();

	payload.append('kod', JSON.stringify(data));

	return aFetch<void | KwardaError>(endPoints.apiBase, {
		fetchArgs: {
			method: 'POST',
			body: payload,
		},
	});
};
